<template>
  <div class="has-navbar-fixed-bottom" v-if="this.chapter !== 'load' && this.episode !== 'load'">
    <nav-bar/>
    <div class="card is-shadowless">
      <div class="card-header is-shadowless">
        <div class="card-header-title subtitle is-centered" v-if="episode">{{ storyTitle }}</div>
      </div>
    </div>
    <dynamic-story :episode="episode" :chapter="chapter" :story="story" :key="storyTitle"/>
  </div>
</template>

<script>
import DynamicStory from '@/components/DynamicStory.vue'
import config from '@/config.js'
export default {

  name: 'StoryTemplate',
  components: {
    DynamicStory
  },
  props: {
  },
  data () {
    return {
      episodes: config.episodes,
      episode: '2',
      chapter: '2',
      story: '1'
    }
  },
  computed: {
    chapters () {
      if (this.chapter !== 'load' && this.episode !== 'load') {
        return this.episodes[this.episode].chapters
      }
      return false
    },
    currentChapter () {
      if (this.chapter !== 'load' && this.episode !== 'load') {
        return this.chapters[this.chapter]
      }
      return false
    },
    storyTitle () {
      if (this.chapter !== 'load' && this.episode !== 'load') {
        return this.currentChapter.titles[this.story]
      }
      return false
    }
  },
  mounted () {
    if (typeof this.currentChapter.titles !== 'undefined') {
      document.title = this.storyTitle + ' - TPFLA'
    }
    this.episodeset = this.episode
    this.chapterset = this.chapter
  },
  watch: {
    storyTitle (to) {
      document.title = this.storyTitle + ' - TPFLA'
    }
  }
}
</script>

<style lang="css" scoped>
.has-navbar-fixed-bottom {
    padding-bottom: 3.25rem;
}
</style>
